var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media audio"},[_c('div',{ref:"player_wrapper",staticClass:"player placeholder"},[_c('vue-plyr',{ref:"plyr_audio",attrs:{"options":{
				hideControls: false,
				controls: ['play', 'progress', 'current-time', 'volume'],
			}}},[_c('div',{staticClass:"plyr__audio-embed"},[_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":"","allowtransparency":"","allow":"autoplay"}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }